/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import css from './share-link.css';
import 'reset-css/reset.css';
import '../color/color';
import '../typography/typography';

const ShareLink = ({ href, icon, inverse, ...otherProps }) => (
  <a
    className={classnames(css['ds-share-link'], {
      [css['ds-share-link--inverse']]: inverse,
    })}
    href={href}
    {...otherProps}
  >
    {icon}
  </a>
);

ShareLink.defaultProps = {
  href: null,
  inverse: false,
};

ShareLink.propTypes = {
  icon: PropTypes.node.isRequired,
  inverse: PropTypes.bool,
  href: PropTypes.string,
};

export default ShareLink;
